module.exports = __webpack_public_path__ + "img/personal_resources_list_right.9b6a2b0d.svg";